export const resolveContent = (slug) => {
  return [ 'contentService', contentService => {
    return contentService.getContent(slug).then(data => data);
  }];
};



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/checkout/resolvers/checkout.resolver.js